<template>
	<div>
		<CHeader :pHeaderProps="HeaderProps">
			<template slot="Contenido">
				<div class="row mt-3">
                    <div class="col-12 col-sm-12">
                        <label for="">Observaciones Críticas</label><small> (max 1500 caracteres)</small>
                        <textarea class="form-control shadow" cols="30" rows="10" maxlength="1500" v-model="ObservacionesCriticas" placeholder="Escriba aquí sus observaciones"></textarea>
                    </div>
                </div>
				<div class="row mt-3 justify-content-center">
					<div class="col-10 col-sm-10 text-center">
                        <button :disabled="DisabledBtn" @click="Guardar" type="button" class="btn btn-01 btn-block btn-grande">
                            <i v-show="DisabledBtn" class="fa fa-spinner fa-pulse fa-fw"></i> Guardar
                            <!-- <i v-show="!DisabledBtn" class="fa fa-check"></i> -->
                        </button>
                    </div>
				</div>
			</template>
		</CHeader>
	</div>
</template>

<script>
import CHeader from "@/views/webapp/components/HeaderWebApp.vue";
export default {
	props:['pEquipo','pServicio'],
	components:{CHeader},
	data() {
		return {
			DisabledBtn:false,
			HeaderProps:{
                ShowSubHeader:true,
                ShowTecnico:false,
                ShowFechaHoy:false,
                ShowMenuDropdown:false,
                ShowFotoPerfil:false,
                ShowReturn:true,
                TextoHeader:'Observaciones Críticas',
                ShowLogo:false,
                TextoCentroSubHeader:''
            },
			Equipo:{},
            Servicio:{},
            ObservacionesCriticas:''
		}
	},
	methods: {
		Guardar(){
			this.DisabledBtn=true;
            let formData=new FormData();
            formData.set('IdServicio',this.Servicio.IdServicio);
            formData.set('ObservacionesCriticas',this.ObservacionesCriticas);
			formData.set('IdEquipo',this.Equipo.IdEquipo);
			this.$http.post('webapp/observacionescriticaspost',formData
            ).then((res)=>{
                this.DisabledBtn=false;
                this.$toast.success('Observación Guardada');
                // this.$router.push({name:'EquiposServicioWebApp'});
            }).catch((err)=>{
                this.DisabledBtn=false;
                this.$toast.warning(err.response.data.message);
            });
		},
		Regresar(){
            this.$router.push({name:'EquiposServicioWebApp'});
        }
	},
	mounted() {
		this.bus.$off('EmitReturn');
        this.bus.$on('EmitReturn',()=>{
            this.Regresar();
        });
        this.Servicio=this.pServicio;
		this.Equipo=this.pEquipo;
		this.HeaderProps.TextoCentroSubHeader=this.Equipo.Nequipo;
		this.ObservacionesCriticas=this.Equipo.ObservacionesCriticas;
	},
}
</script>

<style>

</style>
